import { connect } from "react-redux";
import type { Dispatch } from "redux";
import { bindActionCreators } from "redux";
import { endLoading, restoreLogin, setDarkMode, startLoading } from "~/actions/PreAuthActions/preAuthActions";
import { setIsAuthenticated } from "~/actions/authActions";
import type ReduxStateType from "../../reducers/ReduxStateType";
import Root from "./Root";

const mapStateToProps = (state: ReduxStateType) => ({
    isAuthenticated: state.preAuth.isAuthenticated,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    actions: bindActionCreators({ setIsAuthenticated, restoreLogin, startLoading, endLoading, setDarkMode }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Root);
